import type { PowerRoute } from './types';

export function suggestCableLabel(
  routes: PowerRoute[],
  preferredLabel: string,
  advance = false,
): string {
  const usedLabels = new Set(
    routes.map((route) => route.cableLabel.trim().toLocaleLowerCase()).filter(Boolean),
  );
  const preferred = preferredLabel.trim();

  if (!advance && preferred && !usedLabels.has(preferred.toLocaleLowerCase())) return preferred;

  const match = preferred.match(/^(.*?)(\d+)(\D*)$/);
  if (match) {
    const [, prefix = '', digits = '', suffix = ''] = match;
    let number =
      Number(digits) + (advance || usedLabels.has(preferred.toLocaleLowerCase()) ? 1 : 0);
    let candidate = `${prefix}${String(number).padStart(digits.length, '0')}${suffix}`;
    while (usedLabels.has(candidate.toLocaleLowerCase())) {
      number += 1;
      candidate = `${prefix}${String(number).padStart(digits.length, '0')}${suffix}`;
    }
    return candidate;
  }

  const base = preferred || 'PWR';
  let number = routes.length + 1;
  let candidate = `${base}-${String(number).padStart(2, '0')}`;
  while (usedLabels.has(candidate.toLocaleLowerCase())) {
    number += 1;
    candidate = `${base}-${String(number).padStart(2, '0')}`;
  }
  return candidate;
}
